import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Self-hosted fonts via @fontsource — no CDN, works on-prem/offline.
import '@fontsource/archivo/500.css';
import '@fontsource/archivo/600.css';
import '@fontsource/archivo/700.css';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';

import './index.css';
import 'react-grid-layout/css/styles.css';
import './components/dashboard/dashboardGrid.css';

import { initTheme } from './lib/theme';
import { App } from './App';

// Belt-and-suspenders: index.html runs an inline no-FOUC script (allowlisted in
// the backend CSP by hash) that applies the stored theme before first paint.
// Re-apply from this bundled module so the theme is still restored if that
// inline script is ever blocked — otherwise a refresh reverts to the hardcoded
// light default on <html>.
initTheme();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root was not found in the document.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
